// extracted by mini-css-extract-plugin
export var answer = "FAQ-module--answer--G97KE";
export var answer_expanded = "FAQ-module--answer_expanded--BCoJ0";
export var arrow = "FAQ-module--arrow--xb2pt";
export var arrow_reverted = "FAQ-module--arrow_reverted--jOMz-";
export var container = "FAQ-module--container--xi6yL";
export var question = "FAQ-module--question--PTEqp";
export var question_text = "FAQ-module--question_text--fwTOT";